import { createFileRoute } from '@tanstack/react-router';
import { CostCalculatorPage } from '@/pages/partner/cost-calculator/CostCalculatorPage';

export const Route = createFileRoute('/partner/calculator')({
  component: CostCalculatorPage
});
